import { gsap } from 'gsap'
import { deepMerge } from 'js/utils/Utils'

import Common from 'js/_core/Common'
import FadeInViewItem from 'js/modules/_base/effects/FadeInViewItem'

const defaults = {
  instanceName: 'titleFadeAInViewItem',
  $names: {
    trigger: '[data-anim="title-fade-a-iv"]',
  },
}

export default class TitleFadeAInViewItem extends FadeInViewItem {
  constructor(options = {}) {
    super()
    this._iom = Common.iom3
    deepMerge(this, defaults, options)
  }

  init() {
    super.init()
  }

  destroy() {
    super.destroy()
  }

  setInitialStyle($el, index) {
    gsap.set($el, {
      opacity: 0.1,
    })
  }

  async animateIn($el, index) {
    requestAnimationFrame(() => {
      gsap.to($el, {
        opacity: 1,
        duration: 0.6,
        delay: 0.05,
        ease: 'quad.inOut',
      })
    })
  }
}